
import { Route, Routes } from 'react-router-dom'
import { Layout } from 'frame'
import { Add, Edit, List } from './components'


export const ModuleRoutes = () => (
  <Layout>
    <List />
    <Routes>
      <Route path="add" element={<Add />} />
      <Route path=":id" element={<Edit />} />
    </Routes>
  </Layout>
)
